/**
 * Card query sortable fields
 *
 * @package HOPS
 * @subpackage Cards
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
const CardsQuerySortField = {

	Id: 1,

	CardNo: 2,

	UserId: 3,

	UserSname: 4,

	GeneratedTimestamp: 5,

	ApprovedTimestamp: 6,

	LiveTimestamp: 7,

	ExpiryDate: 8

};

export default CardsQuerySortField;
